import OnlyHeader from "components/Headers/OnlyHeader";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { getManagerHelpRequests } from "store/actions/managerAction";
const ManagerHelper = () => {
  let dispatch = useDispatch();
  const [loader, setLoader] = useState({
    btn: false,
    data: false,
  });
  const { helpRequests, lastDocumentRequest, hasMoreRequest } = useSelector(
    (state) => state.manager
  );

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getManagerHelpRequests("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);

  const loadMore = () => {
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      getManagerHelpRequests(lastDocumentRequest, () => {
        setLoader((prev) => ({
          ...prev,
          btn: false,
        }));
      })
    );
  };
  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 justify-content-between d-flex flex-wrap align-items-center">
                <h3 className="mb-0">Manager Available to Help</h3>
              </CardHeader>
              {loader.data ? (
                <div className="text-center my-4">
                  <Spinner color="primary"></Spinner>
                </div>
              ) : (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Manager Email</th>
                      <th scope="col">Manager name</th>
                      <th scope="col">Request Detail</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Type</th>
                      <th scope="col">CREATED AT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {helpRequests.length > 0 ? (
                      helpRequests.map((items, index) => {
                        console.log(items);
                        return (
                          <tr key={index}>
                            <td>{items.school.email}</td>
                            <td>
                              {items.type == "Athlete"
                                ? items.school.first_name +
                                  " " +
                                  items.school.last_name
                                : items.school.name}
                            </td>
                            <td>{items.requestDetail}</td>
                            <td>{items.phone}</td>
                            <td>{items.type}</td>
                            <td>
                              {moment
                                .unix(items?.created_at.seconds)
                                .format("DD MMM YYYY")}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
              {helpRequests.length > 4 && hasMoreRequest && (
                <div className="text-center my-2">
                  <Button
                    color="primary"
                    onClick={loadMore}
                    disabled={!hasMoreRequest || loader.btn}
                  >
                    {loader.btn ? <Spinner size="sm" /> : "Load More"}{" "}
                  </Button>
                </div>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ManagerHelper;
